import { Box, Button, FileInput, Image, LoadingOverlay, Paper, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageVerticals.module.css'


const AddVerticals = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState<any>('');
    const [verticalname, setVerticalname] = useState<string>('');
    const [imageUrl, setImageUrl] = useState<string>('');
    const [preview, setPreview] = useState<string | null>(null);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token");
    const updatedUrl = baseUrl.replace("/api/", "");
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST';
    const url = id ? `${baseUrl}admin/verticals/update/${id}` : `${baseUrl}admin/verticals/add`;

    const formData = new FormData();
    if (value) formData.append("icon_name", value);
    formData.append("vertical_name", verticalname);
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postvertical,
    } = useFetch({
        method: method,
        referrerPolicy: "no-referrer",
        headers: {
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: formData,
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/verticals/${id}`)
        }

    }, [id]);
    useEffect(() => {
        if (value) {
            const objectUrl = URL.createObjectURL(value);
            setPreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl); // Cleanup
        }
    }, [value]);
    useEffect(() => {
        if (getfieldData) {
            setVerticalname(getfieldData?.data?.rows[0]?.vertical_name)
            setImageUrl(getfieldData?.data?.rows[0]?.icon_name)
        }
    }, [getfieldData]);

    const handleChange = (field: string, value: string | File | null) => {
        if (field === "vertical_name") {
            setVerticalname(value as string);
        }
        if (field === "vertical_icon") {
            setValue(value as File); // Ensure value is stored as a File object
        }

        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };


    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!verticalname) {
            newErrors.vertical_name = "Category Name is Required";
        }
        if (!id) {
            if (!value) {
                newErrors.vertical_icon = "Category Icon is Required";
            } else if (!(value instanceof File)) {
                newErrors.vertical_icon = "Invalid file format";
            }
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        }
        return true;
    };


    const handlesave = async () => {
        if (!validateFields()) return
        await postvertical(url)
    };

    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/manage-verticals');
        }
    }, [getData, getError, navigate, classes]);

    return (
    <>
    <LoadingOverlay
                    visible={getfieldLoading}
                    zIndex={1000}
                    overlayProps={{
                        radius: 'sm',
                        blur: 2,
                        style: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        }
                    }}
                    loaderProps={{ color: '#404040', type: 'bars' }}
                />
        <Paper shadow="xs" p="xs" radius="md">
            <Box ml={5}>
                <Title order={4}>Add Category</Title>
                <Space h="lg" />
                <Text>Category Details</Text>
                <Space h="xs" />
                <SimpleGrid cols={4}>
                    <TextInput
                        variant='filled'
                        value={verticalname}
                        onChange={(e) => handleChange("vertical_name", e.target.value)}
                        label="Category name"
                        withAsterisk
                        placeholder="Category name"
                        radius={6}
                        error={errors.vertical_name} />
                    <FileInput
                        label="Upload icon"
                        withAsterisk={id ? false : true}
                        variant="filled"
                        placeholder="Upload icon"
                        value={value}
                        onChange={(file) => handleChange("vertical_icon", file)}
                        radius={6}
                        error={errors.vertical_icon}
                        />
                    {preview ? (
                        <Box className={classes.verticalslogo}>
                            <Image fit="contain" src={preview} alt="icon" />
                        </Box>
                    ) : id ? <Box className={classes.verticalslogo}>
                        <Image fit="contain" src={`${updatedUrl}${imageUrl}`} alt="icon" />
                    </Box> : null}
                </SimpleGrid>
                <Space h="xl" />
                <SimpleGrid cols={6}>
                    <Button
                        variant="default"
                        radius={6}
                        onClick={() => navigate('/manage-verticals')}
                        >
                        Cancel
                    </Button>
                    <Button
                        variant="gradient"
                        gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                        radius={6}
                        onClick={handlesave}
                        >
                        {id ? 'Update' : 'Save'}
                    </Button></SimpleGrid>
            </Box>
        </Paper>
                        </>
    )
}

export default memo(AddVerticals)
